import React from "react";
import "./SectionHead.css";
export default function SectionHead({title}){
return(
    <>
    <h2 className="section-heading">{title}</h2>
    </>
)
}